technical_communities_opts = [
  "Computational Fluid Dynamics Community",
  "Computational Structural Mechanics Community",
  "Engineering Data Science Community",
  "High Performance Computing Community",
  "Impact, Shock & Crash Community"
  "Multiphysics Community",
  "Optimisation Community",
  "Simulation Data Management Community",
  "Stochastics Community",
  "Systems Modeling & Simulation Community",
  "Systems Modeling & Simulation Community INCOSE"
]

steering_groups_opts = [
  "Americas Chairman",
  "Americas Member",
  "BIWG Chair",
  "BIWG Member",
  "CEMWG Chair",
  "CEMWG Member",
  "CEMWG Vice Chair",
  "CFDWG (provisional)",
  "CFDWG Chair",
  "CFDWG Member",
  "CMFG Chair",
  "CMFG Member",
  "CSDFG Chair",
  "CSDFG Member",
  "CSMWG (provisional)",
  "CSMWG Chair",
  "CSMWG Member",
  "CSMWG Vice Chair",
  "CWG Chair",
  "CWG Member",
  "CWG Vice Chair",
  "DACH Chairman",
  "DACH Member",
  "DSC Chair",
  "DSC Member",
  "DTFG Chair",
  "DTFG Member",
  "DTFG Vice Chair",
  "Eastern Europe Chair",
  "Eastern Europe Member",
  "ETWG Chair",
  "ETWG Member",
  "FAM Chairman",
  "FAM Member",
  "FAM Vice Chair",
  "France Chairman",
  "France Member",
  "France Vendor Council Member",
  "GWG Chair",
  "GWG Member",
  "GWG Vice Chair",
  "HPCWG Chair",
  "HPCWG Member",
  "Iberia Chairman",
  "Iberia Member",
  "India Steering Committee Chairman",
  "India Steering Committee Member",
  "ISCFG Chair",
  "ISCFG Member",
  "Italia Chairman",
  "Italia Member",
  "MAMFG Chair",
  "MAMFG Member",
  "MANWG Chair",
  "MANWG Member",
  "MANWG Vice Chair",
  "MBDFG Chair",
  "MBDFG Member",
  "MMFG Chair",
  "MMFG Member",
  "MPWG Chair",
  "MPWG Member",
  "MPWG Vice Chair",
  "NAFEMS Council Chairman",
  "NAFEMS Council Member",
  "Nordic Chairman",
  "Nordic SG Member",
  "OGFG Chair",
  "OGFG Member",
  "OWG Chair",
  "OWG Community",
  "OWG Member",
  "SDMWG Chair",
  "SDMWG Member",
  "SDMWG Vice Chair",
  "SGMWG (Provisional)",
  "SGMWG Chair",
  "SGMWG Member",
  "SMSWG Chair",
  "SMSWG Member",
  "SMSWG Vice Chair",
  "SWG Chair",
  "SWG Member",
  "TLG Chairman",
  "TLG Member",
  "TLG Vice Chair",
  "UK Chairman",
  "UKSG Member",
  "Vendor Network"
]

module.exports = (original)-> ({React,FormGroup,Pikaday})->
  (props)=> 
    return <div></div> if(!props.user) 
    #make it possible to return global override of component

    extrafields = [
      <FormGroup label="Signup Page" key="signup_page">
        <input type="text" disabled className="form-control" id="signup_page" value={props.user.signup_page || "" }  />
      </FormGroup>
      <FormGroup label="Student Membership" key="student_membership">
        <select id="student_membership" className="form-control" value={props.user.student_membership} onChange={(e)=> props.onUpdate(props.user.id,"student_membership",e.target.value)}>
          <option value="">None</option>
          <option value="Guest">Guest</option>
          <option value="Member">Member</option>
        </select>
      </FormGroup>
      <FormGroup label="Salesforce Id" key="reference">
        <input type="text" className="form-control" id="reference" value={props.user.reference || "" } onChange={(e)=> props.onUpdate(props.user.id,"reference",e.target.value)} />
      </FormGroup>
      <FormGroup label="Can Use Credits" key="use_credits" checkbox={true} >
        <input type="checkbox" id="use_credits" checked={props.user.use_credits || false } onChange={(e)=> props.onUpdate(props.user.id,"use_credits",e.target.checked)} />
      </FormGroup>
      <FormGroup label="Community Id Created?" key="community_id_created" checkbox={true} >
        <input type="checkbox" id="community_id_created" checked={props.user.community_id_created || false } onChange={(e)=> props.onUpdate(props.user.id,"community_id_created",e.target.checked)} />
      </FormGroup>
      <FormGroup label="Technical Communities" key="technical_communities">
        {technical_communities_opts.map (comm,key)=>
          <div className="checkbox" key={key}>
            <label>
              <input type="checkbox" checked={props.user.technical_communities?.split(";")?.indexOf(comm)>-1} onChange={(e)=> 
                updated = props.user.technical_communities?.split(";") || []
                updated = if e.target.checked then updated.concat(comm) else updated.filter (c)=> c!=comm
                props.onUpdate(props.user.id,"technical_communities",updated.join(";"))
              }/> {comm}
            </label>
          </div>
        }
      </FormGroup>
      <FormGroup label="Working & Steeting Groups" key="steering_groups">
        <div  style={{height:250,overflow:"auto",border:"1px solid #ddd"}}>
          {steering_groups_opts.map (comm,key)=>
            <div className="checkbox" key={key}>
              <label>
                <input type="checkbox" disabled checked={props.user.steering_groups?.split(";")?.indexOf(comm)>-1} onChange={(e)=> 
                  updated = props.user.steering_groups?.split(";") || []
                  updated = if e.target.checked then updated.concat(comm) else updated.filter (c)=> c!=comm
                  props.onUpdate(props.user.id,"steering_groups",updated.join(";"))
                }/> {comm}
              </label>
            </div>
          }
        </div>
      </FormGroup>
    ]
    original(props).concat(extrafields)
